import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import api from '../../../api';

import './index.css';

const mapStateToProps = (state) => ({
	mainMenu: state.api.menus.main
});

const mapDispatchToProps = (dispatch) => ({
	loadMenu: (menu) => dispatch({ type: 'LOAD_MENU', payload: menu })
});

class Header extends Component {

	constructor(props) {
		super(props);
		this.props.loadMenu(api.Menus.bySlug('main'));
		this.buildMenu = this.buildMenu.bind(this);
		this.toggleMenu = this.toggleMenu.bind(this);
		this.state = {
			menuOpen: false
		}
	}

	buildMenu() {
		if (this.props.mainMenu) {
			return this.props.mainMenu.map((item, i) => {
				return (
					<Link onClick={()=>{this.toggleMenu()}} key={item.ID} to={item.url}>{item.title}</Link>
				);
			})
		}

		return null;
	}

	toggleMenu() {
		const menuOpen = this.state.menuOpen;
		this.setState({menuOpen: !menuOpen});
	}

	render() {
		
		const headerClass = this.state.menuOpen ? "header-main toggled" : "header-main";
		return (
			<header className={headerClass}>
				<button className="menu-toggle" aria-controls="primary-menu" aria-expanded="false" onClick={() => { this.toggleMenu() }}>
					<i className="close"></i><i className="menu"></i>
				</button>

				<nav id="primary-menu">
					{this.buildMenu()}
				</nav>
				<div className="logo"><a href="/"><span className="screen-reader-text">MIRRAD</span></a></div>
				<div className="footer__gradient-cover"/>
			</header>

		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/layout/Header/index.js